"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getMaxFavoriteSuggestionCounts_1 = require("./getMaxFavoriteSuggestionCounts");
var isInFavorites_1 = require("owa-mail-favorites-store/lib/selectors/isInFavorites");
var owa_session_store_1 = require("owa-session-store");
function getFavoriteSearchSuggestions(findText) {
    var searchHistory = owa_session_store_1.getUserConfiguration().ViewStateConfiguration.SearchHistory;
    var searchSuggestions = [];
    for (var _i = 0, searchHistory_1 = searchHistory; _i < searchHistory_1.length; _i++) {
        var searchEntry = searchHistory_1[_i];
        if (searchEntry.toLowerCase().indexOf(findText.toLowerCase()) == 0) {
            searchSuggestions.push(searchEntry);
        }
    }
    // Filter out search queries that:
    // 1) are already favorites or
    // 2) are empty string searches
    // 3) contain KQL from queries (we want users to add favorite people instead)
    searchSuggestions = searchSuggestions.filter(function (searchQuery) {
        return !isInFavorites_1.isSearchInFavorites(searchQuery) &&
            searchQuery.trim() != '' &&
            searchQuery.toLowerCase().indexOf('from:') == -1;
    });
    var maxSearchSuggestions = getMaxFavoriteSuggestionCounts_1.default().search;
    searchSuggestions.splice(maxSearchSuggestions);
    return searchSuggestions.map(function (seachEntry) {
        return {
            data: seachEntry,
            id: seachEntry,
            type: 2 /* Search */,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });
}
exports.default = getFavoriteSearchSuggestions;
//# sourceMappingURL=getFavoriteSearchSuggestions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-find-favorites/lib/actions/helpers/getFavoriteSearchSuggestions.js
// module id = 6279
// module chunks = 68